import { useState } from "react";
import axios from "../../../axios";
import { useNavigate } from "react-router-dom";
import CoverFabricForm from "./CoverFabricForm";
import ErrorModal from "../../components/ErrorModal";
import handleApiError from "../../../utils/handleApiError";
import SuccessModal from "../../components/SuccessModal";

export default function CoverFabricCreatePage() {
    const [form, setForm] = useState({ name: "" });
    const [image, setImage] = useState(null);
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = new FormData();
        data.append("name", form.name);
        if (image) data.append("image", image);
        console.log(image);
        setLoading(true);
        try {
            await axios.post("/admin/cover-fabrics", data);
            // navigate("/admin/sizes");
            setSuccess("Data berhasil ditambahkan!");
        } catch (err) {
            setError(handleApiError(err));
        } finally {
            setLoading(false);
        }

    };

    return (
        <>
            <ErrorModal error={error} onClose={() => setError("")} />
            <SuccessModal
                message={success}
                onClose={() => {
                    setSuccess("");
                    navigate("/admin/fabrics");
                }}
            />
            <CoverFabricForm
                form={form}
                setForm={setForm}
                image={image}
                setImage={setImage}
                onSubmit={handleSubmit}
                title="Tambah Cover Fabric"
                buttonLabel="Simpan"
            />
        </>
    );
}
